<script setup lang="ts">
import { t } from '@/utils/i18n';

definePage({
  meta: {
    allowAnonymous: true,
  },
});
</script>

<template>
  <div class="max-w-xl mx-auto p-4 my-5">
    <DraggableContainer :header="t('Freqtrade bot Login')" class="px-4 py-2">
      <BotLogin />
    </DraggableContainer>
  </div>
</template>
